var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "manual-content card-item" }, [
    _c("h3", { staticClass: "text-align-center" }, [_vm._v("Efectivo")]),
    _vm._m(0),
    _c("div", { staticClass: "transfer-process" }, [
      _c("div", { staticClass: "transfer-card card-animation-content" }, [
        _c("div", { staticClass: "card-item front-card" }, [
          _vm._m(1),
          _c("div", { staticClass: "card-content content" }, [
            _vm._m(2),
            _c("p", { staticClass: "has-text-centered" }, [
              _vm._v("¿Harás el depósito hoy?"),
            ]),
            _c("div", { staticClass: "buttons-group has-text-centered" }, [
              _c("a", { attrs: { href: "#anchor-will-pay-today" } }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-rounded",
                    class: [
                      _vm.willPayToday
                        ? "is-button-primary"
                        : "is-button-secondary",
                    ],
                    attrs: {
                      id: "button-will-pay-today",
                      disabled: _vm.willPayToday,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.confirmTransaction([false, true])
                      },
                    },
                  },
                  [_vm._v(" Sí, lo haré hoy ")]
                ),
              ]),
              _c("a", { attrs: { href: "#anchor-will-not-pay-today" } }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-rounded",
                    class: [
                      _vm.willPayToday === false
                        ? "is-button-primary"
                        : "is-button-secondary",
                    ],
                    attrs: {
                      id: "button-will-not-pay-today",
                      disabled: _vm.willPayToday === false,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.confirmTransaction([false, false])
                      },
                    },
                  },
                  [_vm._v(" No, aún no ")]
                ),
              ]),
            ]),
            _vm.willPayToday
              ? _c("div", [_vm._m(3), _vm._m(4), _vm._m(5)])
              : _vm._e(),
            _c(
              "p",
              {
                staticClass: "has-text-centered",
                staticStyle: { color: "red" },
              },
              [_vm._v(_vm._s(_vm.errorMessage))]
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "transfer-card card-animation-content" }, [
        _c(
          "div",
          {
            staticClass: "card-item front-card",
            class: { "rotate-left-leave-to": _vm.willPayToday !== undefined },
            attrs: { id: "transfer-image" },
          },
          [
            _c("h4", { staticClass: "has-text-centered" }, [
              _vm._v("Deposita"),
            ]),
            _vm._m(6),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "card-item back-card",
            class: {
              "rotate-left-enter-to": _vm.willPayToday !== undefined,
              show: _vm.willPayToday !== undefined,
            },
            attrs: { id: "card-right-content" },
          },
          [
            _vm.willPayToday === true
              ? _c("div", { attrs: { id: "card-content-will-pay-today" } }, [
                  _vm._m(7),
                  _c("p", [_vm._v("Datos de la cuenta destino:")]),
                  _vm._m(8),
                ])
              : _c(
                  "div",
                  { attrs: { id: "card-content-will-not-pay-today" } },
                  [
                    _vm._m(9),
                    _vm._m(10),
                    _c("p", { staticClass: "block p-4 has-text-centered" }, [
                      _vm._v(
                        " El monto en pesos que calculamos utiliza la UF y, en caso de aplicar, penalización por atraso. Por este motivo, solo aplica si quieres pagar durante el día de hoy. "
                      ),
                    ]),
                    _c("p", { staticClass: "block p-4 has-text-centered" }, [
                      _vm._v(
                        " Vuelve a entrar a verificar el monto el día que quieras pagar efectivamente. "
                      ),
                    ]),
                  ]
                ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "message-info has-text-centered" }, [
      _c("span", [
        _vm._v(
          "Nuestro depósito en efectivo es pagando presencialmente en caja de sucursales BCI."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title-card" }, [
      _c("h4", { staticClass: "is-pulled-left" }, [
        _vm._v("Antes de depositar"),
      ]),
      _c("div", { staticClass: "icon-front is-pulled-right" }, [
        _c("img", {
          attrs: { src: require("@/ui/assets/img/instrucciones.svg") },
        }),
      ]),
      _c("div", { staticClass: "is-clearfix" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        " Debes considerar que el monto en pesos depende de la UF, por lo que es válido "
      ),
      _c("b", [_vm._v("solo por hoy.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "anchor" }, [
      _c("div", { attrs: { id: "anchor-will-pay-today" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("¿Cómo "),
      _c("b", [_vm._v("depositar")]),
      _vm._v(" en la cuenta de Creditú?"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", { staticClass: "transfer-steps" }, [
      _c("li", [_vm._v("Ve a la sucursal del banco BCI más cercana.")]),
      _c("li", [_vm._v("Rellena la papeleta de depósito y paga en la caja.")]),
      _c("li", [
        _vm._v("Envía un correo a "),
        _c("a", { attrs: { href: "mailto:pagos@creditu.com" } }, [
          _vm._v("pagos@creditu.com"),
        ]),
        _vm._v(" con la foto del comprobante."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-back" }, [
      _c("img", { attrs: { src: require("@/ui/assets/img/transfiere.svg") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title-card" }, [
      _c("h4", { staticClass: "is-pulled-left" }, [_vm._v("Deposita")]),
      _c("div", { staticClass: "icon-front is-pulled-right" }, [
        _c("img", {
          attrs: { src: require("@/ui/assets/img/transfiere.svg") },
        }),
      ]),
      _c("div", { staticClass: "is-clearfix" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "account-data" }, [
      _c("li", [
        _c("div", { staticClass: "is-pulled-left" }, [
          _c("span", { staticClass: "label" }, [_vm._v("Titular")]),
          _vm._v("Creditu S.A."),
        ]),
        _c("div", { staticClass: "is-clearfix" }),
      ]),
      _c("li", [
        _c("div", { staticClass: "is-pulled-left" }, [
          _c("span", { staticClass: "label" }, [_vm._v("RUT")]),
          _vm._v("76.594.721-9"),
        ]),
        _c("div", { staticClass: "is-clearfix" }),
      ]),
      _c("li", [
        _c("span", { staticClass: "label" }, [_vm._v("Banco")]),
        _vm._v("Banco de Crédito e Inversiones (BCI)"),
      ]),
      _c("li", [
        _c("span", { staticClass: "label" }, [_vm._v("Tipo de cuenta")]),
        _vm._v("Cuenta Corriente"),
      ]),
      _c("li", [
        _c("div", { staticClass: "is-pulled-left" }, [
          _c("span", { staticClass: "label" }, [_vm._v("Número de cuenta")]),
          _vm._v("35428546"),
        ]),
        _c("div", { staticClass: "is-clearfix" }),
      ]),
      _c("li", [
        _c("div", { staticClass: "is-pulled-left" }, [
          _c("span", { staticClass: "label" }, [_vm._v("Correo electrónico")]),
          _vm._v("pagos@creditu.com"),
        ]),
        _c("div", { staticClass: "is-clearfix" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "anchor" }, [
      _c("div", { attrs: { id: "anchor-will-not-pay-pay-today" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title-card" }, [
      _c("h4", { staticClass: "is-pulled-left" }, [_vm._v("¡Te esperamos!")]),
      _c("div", { staticClass: "icon-front is-pulled-right" }, [
        _c("img", {
          attrs: { src: require("@/ui/assets/img/transfiere.svg") },
        }),
      ]),
      _c("div", { staticClass: "is-clearfix" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }